.wrapper {
  display: flex;
  align-items: center;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: var(--space-sm) var(--space-md);
  gap: var(--space-sm);
  transition: all var(--transition-fast);
  margin-bottom: var(--space-lg);
}

.wrapper:focus-within {
  border-color: var(--accent-cyan);
  box-shadow: 0 0 10px var(--glow-cyan);
}

.prefix {
  color: var(--accent-cyan);
  font-size: var(--text-sm);
  opacity: 0.7;
}

.input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: var(--text-primary);
  font-family: var(--font-code);
  font-size: var(--text-sm);
}

.input::placeholder {
  color: var(--text-muted);
  letter-spacing: 1px;
}

.clear {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: var(--text-lg);
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color var(--transition-fast);
}

.clear:hover {
  color: var(--accent-magenta);
}
